import * as React from "react";

export const Section01 = () => (
  <div className="content">
    <div className="template-block">
      <img
        className="template-single"
        src="/images/resources/connection-circle-botgs/connection-circle-botgs.svg"
        alt="Connection Circle BOTGs"
      />
    </div>
  </div>
);
